import { render, staticRenderFns } from "./pointsRule.vue?vue&type=template&id=0e2599d2&scoped=true"
import script from "./pointsRule.vue?vue&type=script&lang=js"
export * from "./pointsRule.vue?vue&type=script&lang=js"
import style0 from "./pointsRule.vue?vue&type=style&index=0&id=0e2599d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2599d2",
  null
  
)

export default component.exports